import LoadingIcons from 'react-loading-icons'
function Aguarde(props) {
    return (
        <center>
            <LoadingIcons.Puff strokeOpacity={.125}  stroke='#000' />
            <h1>{props.titulo}</h1>
        </center>
    );
}

export default Aguarde;